import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';

const ViewLink = ({ 
    urlPostback, 
    gethParams, 
    extraGethParams, 
    t 
}) => {
    const [state, setState] = useState({
        urlPostback: urlPostback || '',
        gethParams: gethParams || []
    });

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            urlPostback: urlPostback || prevState.urlPostback,
            gethParams: gethParams || prevState.gethParams
        }));
    }, [urlPostback, gethParams]);

    const getParams = useCallback((list) => {
        let link = '';
        let count = 0;

        list.map((item, i) => {
            const value = item.macros || item.value;

            if (!item.name || !value) {
                return;
            }

            link += (count !== 0) ? '&' : '';
            link += `${item.name}=${value}`;
            count += 1;
        });

        return link;
    }, []);

    const getLink = useCallback(() => {
        let link = state.urlPostback;

        link += link ? '?' : '';
        link += getParams(state.gethParams);

        return link;
    }, [state.urlPostback, state.gethParams, getParams]);

    return (
        <div className="viewLink">
            {getLink()}
        </div>
    );
};

ViewLink.propTypes = {
    urlPostback: PropTypes.string,
    gethParams: PropTypes.array,
    extraGethParams: PropTypes.array,
    t: PropTypes.object
};

ViewLink.defaultProps = {
    urlPostback: '',
    gethParams: [],
    extraGethParams: [],
    t: {}
};

export default withTranslation(ViewLink);